<template>
  <el-tabs :value="detailAuth ? 'first' : recordAuth ? 'second' : 'third'" type="card" @tab-click="tabChange">
    <el-tab-pane v-if="detailAuth" label="物料打印项配置" name="first">
      <material-label-print-list ref="detail"/>
    </el-tab-pane>
    <el-tab-pane v-if="recordAuth" label="标签打印记录" name="second">
      <material-label-print-record-list ref="record"/>
    </el-tab-pane>
    <el-tab-pane v-if="templateAuth" label="标签模板配置" name="third">
      <material-label-print-template-list ref="template"/>
    </el-tab-pane>
    <el-tab-pane v-if="imageAuth" label="标签图片管理" name="fourth">
      <material-label-print-image-list ref="image"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

  import MaterialLabelPrintTemplateList from "@/views/MaterialLabel/MaterialLabelPrintTemplateList.vue";
  import MaterialLabelPrintList from "@/views/MaterialLabel/MaterialLabelPrintList.vue";
  import MaterialLabelPrintRecordList from "@/views/MaterialLabel/MaterialLabelPrintRecordList.vue";
  import MaterialLabelPrintImageList from "@/views/MaterialLabel/MaterialLabelPrintImageList.vue";

  export default {
    name: "MaterialLabelTabs",
    components: {
      MaterialLabelPrintImageList,
      MaterialLabelPrintRecordList, MaterialLabelPrintList, MaterialLabelPrintTemplateList},
    data() {
      return {
        detailAuth: this.$auth(722),
        recordAuth: this.$auth(731),
        templateAuth: this.$auth(736),
        imageAuth: this.$auth(753),
      };
    },
    methods: {
      tabChange(tab) {
        if (tab.name === "first") {
          this.$refs.detail.getList(1);
        }
        if (tab.name === "second") {
          this.$refs.record.getList(1);
        }
        if (tab.name === "third") {
          this.$refs.template.getList(1);
        }
        if (tab.name === "fourth") {
          this.$refs.image.getList(1);
        }
      },
    },
  };
</script>

<style scoped>

</style>
